export default {

  userList: [],
  userInfo: {},
  userJobs: [],
  assetList: [],

  groupList: [],
  groupNames: [],
  groupMembers: [],

  noticeGroup: [],
  noticeList: [],
  userNoticeList: [],
  userArchiveNoticeList: [],
  managerNoticeList: [],
  managerHistoryNoticeList: [],
  noticeDetails: null,
  userNoticeDetails: [],

  fileAddress: null,

};
